import { createRequestConstantNames } from 'store/util/createConstants';
import createReduxConstant from 'store/util/createReduxConstant';

export const [
  REFUND_ROOM_RESERVATION,
  REFUND_ROOM_RESERVATION_SUCCESS,
  REFUND_ROOM_RESERVATION_FAIL,
] = createRequestConstantNames(createReduxConstant('REFUND_ROOM_RESERVATION'));
